import React, { Component } from 'react';
import Axios from 'axios'
import querystring from 'query-string'
import './style.css'
import { DB_URL } from '../../helpers/url';
import { Link } from 'react-router-dom';

class Verified extends Component {
    state = {
        success:0
    }

    componentDidMount(){
        console.log(this.props.location.search)
        var obj=querystring.parse(this.props.location.search)
        console.log(obj)
        Axios.get(`${DB_URL}/auth/verified`,
        {
            headers:{
                'Authorization':`Bearer ${obj.token}`
            }
        })
        .then((res)=>{
            // localStorage.setItem('datauser',JSON.stringify(res.data))
            // this.props.verifiedaction(res.data)
            this.setState({success:1})
        }).catch((err)=>{
            console.log(err)
            this.setState({success:2})
        })
    }

    render() {
        console.log(this.props.Auth)
        if(this.state.success===1){
            return(
            <div>
                <center>
                    <h1>
                       Your account have been verified
                    </h1>
                    <Link to='/login'>Click here to go back on login screen </Link>
                </center>
            </div>
            )
        }else if(this.state.success===2){
            return(
            <div>
                <center>
                    <h1>
                       gagal verified
                    </h1>
                </center>
            </div>
            )
        }
        return (
            <div>
                <center>
                    <h1>
                        sedang menunggu verified
                    </h1>
                </center>
            </div>
          );
    }
}


export default Verified;